import React, { memo } from 'react';
import UseDfpSlot from './UseDfpSlot';

const LateralDerecho = () => {
    
    UseDfpSlot({
        path: '/28253241/depor/web/post/default/lateralr',
        size: [[160, 600], 'fluid', [120, 600]],
        id: 'div-gpt-ad-1582159394135-0',
    });

    return (
        <aside className="d-none d-xl-block position-fixed end-0 me-4 text-start lateral-der">
            <div id="div-gpt-ad-1582159394135-0"></div> 
        </aside>
    )
}

export default memo(LateralDerecho);
